import {
    Code,
    Compass,
    Layers,
    Rocket,
    Wrench,
} from "lucide-react";

const technologiesProcess = [
    {
        step: 1,
        title: "Discovery & Requirement Mapping",
        description:
            "We start by understanding your business, users, and long-term goals. This shapes every technical decision that follows — no assumptions, only informed choices.",
        icon: <Compass />,
    },
    {
        step: 2,
        title: "Stack Selection",
        description:
            "Based on your needs — real-time, AI-heavy, high-traffic, offline-first — we recommend the optimal combination of frontend, backend, database, and cloud technologies.",
        icon: <Layers />,
    },
    {
        step: 3,
        title: "Architect & Prototype",
        description:
            "We design a scalable architecture, wire up a working prototype, and validate the core assumptions before writing production code.",
        icon: <Code />,
    },
    {
        step: 4,
        title: "Build, Test & Harden",
        description:
            "Feature development runs in tight sprints with automated tests, code reviews, and security audits — ensuring production-ready quality on every commit.",
        icon: <Wrench />,
    },
    {
        step: 5,
        title: "Deploy & Scale",
        description:
            "We ship via CI/CD, monitor every service in production, and evolve your stack as you grow — from MVP to millions of users.",
        icon: <Rocket />,
    },
];

export default technologiesProcess;
